import { useTheme } from '@material-ui/core';
import { Button } from 'app/components/BasicButtons/Button';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export interface SelectLoginTypeProps {
  onSSO_ON_Submit: () => void;
  onSSO_OFF_Submit: () => void;
}
export const LoginButtons = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '16px',
  alignSelf: 'stretch',
}));
export function SelectLoginType(props: SelectLoginTypeProps) {
  const { t } = useTranslation();
  const theme = useTheme();
  return (
    <LoginButtons theme={theme}>
      <Button
        variant="main"
        size="large"
        fullWidth
        onClick={props.onSSO_ON_Submit}
        id={'auth_ssoId'}
      >
        {t(translations.auth_ShibbolethLoginLinkText)}
      </Button>
      <Button
        variant="white"
        size="large"
        fullWidth
        id={'auth_bookitId'}
        onClick={props.onSSO_OFF_Submit}
      >
        {t(translations.SignInWithCredentials)}
      </Button>
    </LoginButtons>
  );
}
